import { OPEN_SUBMENU, CLOSE_SUBMENU } from "../actions/subMenuActionTypes";

const initialState = {
    openSubMenuId: null,
};

const subMenuReducer = (state = initialState, action) => {
    switch (action.type) {
        case OPEN_SUBMENU:
            return {
                ...state,
                openSubMenuId: action.payload,
            };
        case CLOSE_SUBMENU:
            return {
                ...state,
                openSubMenuId: null,
            };
            default:
                return state;
    }
};

export default subMenuReducer;